import React from 'react'
import cookie from "react-cookies";

const EasyMiddleware = {
    resetPassword: true,
    checkResetPassword() {
        axios.get(
            '/api/user',
            {headers: {Authorization: cookie.load('apiToken')}})
            .then((response) => {
                this.resetPassword = response.data.user.password_reset
                this.redirectIfNeeded()
            })
            .catch(function (error) {
                if (error.response.status === 401) {
                    window.postMessage('logout')
                }

            })
    },

    redirectIfNeeded() {
        if (this.resetPassword) location.href = '/reset-password'
    }
}

export {EasyMiddleware}


// WEBPACK FOOTER //
// ./resources/js/components/EasyMiddleware.js